<template>
  <div style="background: #f0f4f7">
    <!-- <AboutBanner :content="banners.find(item=>item.id === 119).details"
                 :title="banners.find(item=>item.id === 119).title"
                 :img="banners.find(item=>item.id === 119).photo_file"/> -->
    <BlockCatalogue/>
    <BlockArticles/>
    <BlockCertificates/>
  </div>
</template>

<script>
import BlockCatalogue from "./Catalogue/BlockCatalogue";
import BlockArticles from "./articles/BlockArticles";
import BlockCertificates from "./certificates/BlockCertificates";
import AboutBanner from "../About/Components/AboutBanner";
import AboutTitle from "../About/Components/AboutTitle";
import {mapState} from "vuex";

export default {
  name: "BaseTechnical",
  components: {
    AboutTitle,
   AboutBanner, BlockCertificates, BlockArticles, BlockCatalogue},
  created() {
    if (this.banners==null){
      this.$store.dispatch('glassManagement/getGlassBanners');
    }
  },

  computed: {
    ...mapState({
      banners: state => state.glassManagement.glassBanners,
    })
  }
}
</script>

<style scoped>

</style>